import { ActionIcon, Drawer, useMantineColorScheme } from '@mantine/core';
import { IconMaximize, IconX } from '@tabler/icons-react';
import { useRouter } from 'next/router';
import { useProjectId } from '~/hooks/context/useProjectId';
import { ZIndexProvider } from '~/hooks/context/useZIndex';
import TestView from './TestView';
import Link from 'next/link';

const DRAWER_Z_INDEX = 300;

export default function TestViewDrawer({
  testId,
  opened,
  onClose,
  initialTab = 'details',
}: {
  testId?: string;
  opened: boolean;
  onClose: () => void;
  initialTab?: string;
}) {
  const projectId = useProjectId();
  const router = useRouter();
  const { colorScheme } = useMantineColorScheme();
  const iconColor = colorScheme === 'dark' ? '#fff' : '#555';

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title={null}
      position="right"
      size="93%"
      zIndex={DRAWER_Z_INDEX}
      withCloseButton={false}
      classNames={{
        body: 'p-0 h-full',
        root: `z-[${DRAWER_Z_INDEX}]`,
        content: 'overflow-y-auto',
      }}
    >
      <ZIndexProvider zIndex={DRAWER_Z_INDEX}>
        <div className="flex h-full flex-col">
          <div className="sticky top-0 z-50 bg-white px-4 dark:bg-zinc-900">
            <div className="flex items-center gap-2 border-b py-2 dark:border-zinc-700">
              <ActionIcon
                onClick={onClose}
                variant="transparent"
                aria-label="Close drawer"
              >
                <IconX
                  size={18}
                  stroke={1.5}
                  color={iconColor}
                />
              </ActionIcon>
              <ActionIcon
                variant="transparent"
                aria-label="Full page view"
                component={Link}
                href={`/project/${projectId}/test/${testId}?tab=${initialTab || router.query.tab || 'details'}`}
              >
                <IconMaximize
                  size={18}
                  stroke={1.5}
                  color={iconColor}
                />
              </ActionIcon>
            </div>
          </div>
          <div className="flex-1 overflow-auto">
            {!!testId && (
              <TestView
                testId={testId}
                initialTab={initialTab}
                isInDrawer={true}
              />
            )}
          </div>
        </div>
      </ZIndexProvider>
    </Drawer>
  );
}
